import Draggable from "react-draggable";
import React, { useEffect, useRef, useState, FormEvent } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { useGetEnumsQuery } from "../../../../app/globalApi";
import Form from "../../../../components/common/form/Form";
import Modal from "../../../../components/common/form/Modal";
import InputField from "../../../../components/common/form/InputField";
import SelectField from "../../../../components/common/form/SelectField";
import { booleanChecks, createOptionListForSelectTag } from "../../../../helpers/utils/Utils";
import ButtonTray from "../../../../components/common/form/ButtonTray";
import { useCreateParentAccountBySubdivisionIdMutation, useUpdateParentAccountMutation } from "../parentAccountApi";


// 👇 Props typing
interface ParentAccountFieldsProps {
    show: boolean;
    setShow: (show: boolean) => void;
    formType: "Add" | "Update";
    parentId?: string;
    title: any,
    parentAccountByIdData?: any;
}

// 👇 Component
export default function ParentAccountFields({
    show,
    setShow,
    formType,
    parentId,
    title,
    parentAccountByIdData = null
}: ParentAccountFieldsProps): JSX.Element {
    const dispatch = useDispatch();
    const { subdivisionId } = useParams<{ subdivisionId: string }>();

    const { data: enums } = useGetEnumsQuery("");
    const BillStatusEnums = useGetEnumsQuery("BillStatus");

    const [accountNumber, setAccountNumber] = useState<string | null>(null);
    const [rollBackStatus, setRollBackStatus] = useState<string | null>(null);
    const [accountStatus, setAccountStatus] = useState<string | null>(null);
    const [included, setInclude] = useState<boolean>(true);
    const [disable, setDisable] = useState<boolean>(false);
    const [bounds, setBounds] = useState<{ left: number; right: number }>({ left: 0, right: 0 });
    const draggleRef = useRef<HTMLDivElement>(null);
    const [creatApi, createApiRes] = useCreateParentAccountBySubdivisionIdMutation();
    const [updateApi, updatepiRes] = useUpdateParentAccountMutation();

    const dismissModal = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        setShow(false);
    };

    const parentAccountBody = {
        accountNumber: accountNumber,
        rollbackStatus: rollBackStatus,
        accountStatus: accountStatus,
        included: included,
        subdivisionId: subdivisionId
    };

    useEffect(() => {
        if (parentAccountByIdData?.data) {
            setAccountNumber(parentAccountByIdData.data.accountNumber);
            setRollBackStatus(parentAccountByIdData.data.rollbackStatus);
            setAccountStatus(parentAccountByIdData.data.accountStatus);
            setInclude(parentAccountByIdData.data.included);
        }
    }, [parentAccountByIdData]);

    const handleSubmit = (e: FormEvent) => {
        e.preventDefault();
        setDisable(true);

        if (accountNumber) {
            formType === "Add"
                ?
                creatApi({
                    requestBody: parentAccountBody,
                    id: subdivisionId,
                }
                )
                : updateApi({
                    requestBody: parentAccountBody,
                    id: parentId,
                })
            setShow(false)
        }
    };

    return (
        <Modal
            title={title}
            show={show}
            setShow={setShow}
            className={"w-2/6  bg-text-0 text-surface-0"}
            fields={
                <>
                    <div className="modal-body">
                        <Form
                            onSubmit={handleSubmit}
                            fields={
                                <>
                                    <InputField
                                        label="Account No"
                                        className="form-control"
                                        type="text"
                                        name="accountNumber"
                                        value={accountNumber ?? ""}
                                        onChange={(e) => setAccountNumber(e.target.value)}
                                        placeholder="Enter Account No..."
                                        required
                                    />
                                    <SelectField
                                        placeholder="Select Rollback Status..."
                                        value={createOptionListForSelectTag(enums?.["AccountRollbackStatus"], "value", "constant")
                                            ?.find(option => option.value === rollBackStatus)}
                                        options={createOptionListForSelectTag(enums?.["AccountRollbackStatus"], "value", "constant")}
                                        onChange={(selectedOption) => setRollBackStatus(selectedOption?.value)}
                                        label="Rollback Status"
                                    />

                                    <SelectField
                                        placeholder="Select Account Status..."
                                        value={createOptionListForSelectTag(enums?.["BillStatus"], "value", "constant")
                                            ?.find(option => option.value === accountStatus)}
                                        options={createOptionListForSelectTag(enums?.["BillStatus"], "value", "constant")}
                                        onChange={(selectedOption) => setAccountStatus(selectedOption?.value)}
                                        label="Account Status"
                                    />

                                    <SelectField
                                        placeholder="Select Included..."
                                        value={createOptionListForSelectTag(booleanChecks, "label", "value")
                                            ?.find(option => option.value === included)}
                                        options={createOptionListForSelectTag(booleanChecks, "label", "value")}
                                        onChange={(selectedOption) => setInclude(selectedOption?.value)}
                                        label="Include on Certificate"
                                    />


                                    <div className="form-group row mt-3">

                                        <ButtonTray
                                            buttons={[
                                                {
                                                    buttonProps: {
                                                        btnText: "Cancel",
                                                        onClick: () => setShow(false),
                                                        type: "close",
                                                    },
                                                    buttonType: "button"
                                                },
                                                {
                                                    buttonProps: {
                                                        btnText: formType,
                                                        type: "submit",
                                                        isLoading: createApiRes.isLoading || updatepiRes.isLoading,
                                                    },
                                                    buttonType: "button",
                                                }
                                            ]}

                                            gap={2}
                                        />

                                    </div>
                                </>
                            }
                        />
                    </div>
                </>
            }
        />
    );
}
